// src/products/capRaise/pages/ScenariosPage.js
// Scenario modeling page for CapRaise

import React from 'react';
import { TrendingUp } from 'lucide-react';
import ValuationExitAnalysis from '../components/ValuationExitAnalysis';

const ScenariosPage = ({ selectedCompany, activeRound, user, addMessage }) => {

  // Check if we have the required data
  const hasRequiredData = selectedCompany && activeRound && activeRound.round_name && activeRound.target_amount;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Scenarios</h1>
          {activeRound?.round_name && (
            <p className="text-gray-600 mt-1">
              {activeRound.round_name}
            </p>
          )}
        </div>
      </div>

      {/* Content */}
      {hasRequiredData ? (
        <ValuationExitAnalysis
          roundData={{
            name: activeRound.round_name,
            target_amount: activeRound.target_amount,
            pre_money_valuation: activeRound.pre_money_valuation,
            round_type: activeRound.round_type,
            currency: activeRound.currency || 'USD'
          }}
          selectedCompany={selectedCompany}
          user={user}
          addMessage={addMessage}
        />
      ) : (
        <div className="text-center py-16 border-2 border-dashed border-gray-300 rounded-lg">
          <TrendingUp className="mx-auto h-16 w-16 text-gray-400 mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No Active Round</h3>
          <p className="text-gray-600 mb-6 max-w-md mx-auto">
            Please create or select a fundraising round to model investment scenarios.
          </p>
          <div className="text-sm text-gray-500">
            <p><strong>To get started:</strong></p>
            <ul className="mt-2 space-y-1">
              <li>• Select a company from the dashboard</li>
              <li>• Create a new fundraising round</li>
              <li>• Define key inputs like target amount and valuation</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScenariosPage;

